<template>
  <a-card
    title="基本信息"
    size="small"
    :headStyle="{
      background: '#f3f3f3',
    }"
  >
    <div class="container">
      <div class="left">
        <div>订单编号:</div>
        <div>大编码:/</div>
        <div>预定时间:</div>
        <div>订票员编号:</div>
        <div>订单备注:</div>
      </div>
      <div class="left">
        <div>订单状态:</div>
        <div>外部订单编号:/</div>
        <div>PNR:</div>
        <div>订票员姓名:</div>
        <div>生单渠道:</div>
      </div>
      <div class="left">
        <div>锁单人:</div>
        <div>所属分销商:/</div>
        <div>原PNR:</div>
        <div>支付状态:</div>
        <div>第三方订单号:</div>
      </div>
    </div>
  </a-card>
  <!-- header of end-->
  <a-card
    class="m"
    size="small"
    title="航班信息"
    :headStyle="{
      background: '#f3f3f3',
    }"
  >
    <a-table :columns="columns" bordered></a-table>
  </a-card>
  <a-card
    size="small"
    title="乘机人信息"
    class="m"
    :headStyle="{ background: '#f3f3f3' }"
  >
    <a-table :columns="columns1" bordered></a-table>
  </a-card>

  <div style="margin-top: 1000px"></div>
</template>
<script>
import { reactive, getCurrentInstance } from "vue";
import orderApi from "@axios/order";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
export default {
  setup() {
    const route = useRoute();
    // let row = route.params.row;
    // console.log(JSON.parse(row));
    // let getDetail = () => {
    //   axios({
    //     url:
    //       "http://39.100.132.94:3000/mock/11/app-admin/express/bill/trip/list",
    //     method: "get",
    //   }).then((res) => {
    //     console.log(res);
    //   });
    // };
    let columns = [
      {
        title: "航程类型",
        align: "center",
        width: 200,
      },
      {
        title: "航程",
        align: "center",
        width: 300,
      },
      {
        title: "航班号",
        align: "center",
        width: 200,
      },
      {
        title: "航位",
        align: "center",
        width: 200,
      },
      {
        title: "起飞时间",
        align: "center",
        width: 200,
      },
      {
        title: "到达时间",
        align: "center",
        width: 200,
      },
      {
        title: "航站楼",
        align: "center",
        width: 200,
      },
    ];
    let columns1 = [
      {
        title: "乘机人",
        align: "center",
      },
      {
        title: "证件号码",
        align: "center",
      },
      {
        title: "性别",
        align: "center",
      },
      {
        title: "出生日期",
        align: "center",
      },
      {
        title: "联系方式",
        align: "center",
      },
      {
        title: "票号",
        align: "center",
      },
      {
        title: "票面价",
        align: "center",
      },
      {
        title: "机建",
        align: "center",
      },
      {
        title: "税费",
        align: "center",
      },
      {
        title: "保险",
        align: "center",
      },
    ];
    return {
      columns,
      columns1,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.container {
  display: flex;
  justify-content: left;
  div {
    margin-right: 50px;
    padding: 10px;
  }
}
.ant-card /deep/ .ant-card-body {
  padding: 0 !important;
}
.m {
  margin-top: 20px;
}
</style>